import { useState, useEffect } from 'react';
import Logo from './Logo';
import { startCheckout } from '../utils/checkout';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="nav-inner">
        <a href="#top" className="nav-brand" aria-label="SolidlyAI Agents home">
          <span className="nav-logo" aria-hidden="true">
            <Logo size={26} />
          </span>
          <span className="nav-brand-text">
            SolidlyAI <span className="nav-brand-accent">Agents</span>
          </span>
        </a>

        <nav className="nav-links" aria-label="Primary">
          <a href="#features">Features</a>
          <a href="#meetings">Meetings</a>
          <a href="#how-it-works">How it works</a>
          <a href="#pricing">Pricing</a>
        </nav>

        <button className="btn btn-primary btn-sm" onClick={() => startCheckout('nav')}>
          Buy — $25
        </button>
      </div>
    </header>
  );
};

export default Navigation;
